import { render } from "./IndexView.vue?vue&type=template&id=6d297df3"
const script = {}

import "./IndexView.vue?vue&type=style&index=0&id=6d297df3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__